// extracted by mini-css-extract-plugin
export default {"archiveWrap":"Archive_archiveWrap__cwTo2"};